/**
 * @generated SignedSource<<fa5df0d5b74f1bc8211d56db57ae5a37>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AdminMembersReportChannelsTableRowFragment$data = {
  readonly id: string;
  readonly lastActivity: {
    readonly eventDatetime: string;
  } | null;
  readonly productApp: {
    readonly customAppTitle: string | null;
    readonly product: {
      readonly name: string;
    } | null;
  } | null;
  readonly totalMessagesSent: number;
  readonly " $fragmentType": "AdminMembersReportChannelsTableRowFragment";
};
export type AdminMembersReportChannelsTableRowFragment$key = {
  readonly " $data"?: AdminMembersReportChannelsTableRowFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportChannelsTableRowFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "organizationMembershipId",
    "variableName": "organizationMembershipId"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "organizationMembershipId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminMembersReportChannelsTableRowFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductApp",
      "kind": "LinkedField",
      "name": "productApp",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "customAppTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Product",
          "kind": "LinkedField",
          "name": "product",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "kind": "ScalarField",
      "name": "totalMessagesSent",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "ReportingUserActivity",
      "kind": "LinkedField",
      "name": "lastActivity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "eventDatetime",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ChatChannel",
  "abstractKey": null
};
})();

(node as any).hash = "df00b51784d30b7773c0cd82cefbe544";

export default node;
